import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/PromoStripWrapper.scss';
import { MediaFullPageBlock } from 'dw-contentful-components';

const props = {
  brand: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

const MediaBlockWrapper = ({ brand, data }) => {
  const { asset, hasBackground, mediaHeading, roundal, roundalBackgroundColour, roundalPosition } = data;
  const url = asset?.file?.url;
  const fileName = asset?.file?.fileName;
  const backgroundStyling = hasBackground ? 'bg-shadow' : '';

  return (
    <div
      data-testid="media-block-wrapper"
      className={`${brand} ${backgroundStyling} media-block-wrapper`}
    >
      <MediaFullPageBlock
        url={url}
        fileName={fileName}
        mediaHeading={mediaHeading}
        roundal={roundal}
        roundalBackgroundColour={roundalBackgroundColour}
        roundalPosition={roundalPosition}
      />
    </div>
  );
};

MediaBlockWrapper.propTypes = props;

export { MediaBlockWrapper };
